import { HttpClient } from "./http";

class SuspiciosTransaction extends HttpClient {
    constructor() {
        super()
    }

    // public async getComplaintReasonCode(id: any, reasonId?: any) {
    //     return this.HTTP.get(`/fleet/complaint/reason-code`, {
    //         params: {
    //             category: id,
    //             reason_code: reasonId,

    //         }
    //     })
    // }
     public async getComplaintReasonCode(id: any, reasonId?: any, result?: any) {
        let query = `category=${id}&reason_code=${reasonId || ''}`;

        if (Array.isArray(result)) {
            result.forEach((val: string) => {
                query += `&type=${val}`;
            });
        } else if (result) {
            query += `&type=${result}`;
        }

        return this.HTTP.get(`/fleet/complaint/reason-code?${query}`);
    }
    public async getComplaintDetail(id: any) {
        return this.HTTP.get(`/fleet/complaint?transaction_id=${id}`)
    }
    public async createComplaint(data: any) {
        return this.HTTP.post(`/fleet/complaint/create`, data)
    }
    public async getSupiciosCount(start: any, end: any) {
        return this.HTTP.get(`/fleet/suspicious-transaction/complaint-reason-count?start=${start}&end=${end}`)
    }
    public async getTransactionData(id: any) {
        return this.HTTP.get(`/fleet/transaction/${id}`)
    }

}

export const SuspiciousTranService = new SuspiciosTransaction();
